import { render } from "./held-button.vue?vue&type=template&id=10e9129c&scoped=true&ts=true"
import script from "./held-button.vue?vue&type=script&lang=ts"
export * from "./held-button.vue?vue&type=script&lang=ts"

import "./held-button.vue?vue&type=style&index=0&id=10e9129c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e9129c"]])

export default __exports__